import { m } from 'framer-motion';
import { styled } from '@mui/material/styles';
import { Container } from '@mui/system';
import { Grid, List, ListItem, Typography } from '@mui/material';
import { PropTypes } from 'prop-types';
//  import { varFade } from '../../animate';
import MotionViewport from '../../animate/MotionViewport';

DetailAddress.propTypes = {
  list: PropTypes.array,
};

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(2, 0),
  backgroundColor: theme.palette.background.paper,
}));

export default function DetailAddress({ list }) {
  const hideList = list.every((item) => item.value.length === 0);

  return (
    !hideList && (
      <RootStyle className="printable">
        <Container component={MotionViewport} sx={{ position: 'relative', height: '100%' }}>
          <m.div /*   variants={varFade().inUp}   */>
            {/* <Grid container>
                        <Grid item xs={12} className="text-left">
                            <Typography variant="h4">{ title }</Typography>
                        </Grid>
                    </Grid> */}
            {/* <Grid container>
                        <Grid item xs={12} className="text-left">
                            { list.map((line, idx) => <Typography key={idx} variant="body1">{ line.value }</Typography> ) }
                        </Grid>
                    </Grid> */}
            <Grid container sx={{ pl: 2, pr: 2 }}>
              <Grid item xs={12} className="text-left">
                <List sx={{ listStyleType: 'disc' }}>
                  {list.map(
                    (line, idx) =>
                      !!line.value.length && (
                        <ListItem key={idx} sx={{ display: 'list-item' }}>
                          <Typography variant="body1" fontSize={17}>
                            {line.value}
                          </Typography>
                        </ListItem>
                      )
                  )}
                </List>
              </Grid>
            </Grid>
          </m.div>
        </Container>
      </RootStyle>
    )
  );
}
